import { Grid as FfeGrid, type GridProps } from "@sb1/ffe-grid-react";
import classNames from "classnames";
import type { FC, RefObject } from "react";
import { backgroundColorClass, type GridBackgroundColor } from "../ffeGridUtils";
import { TrackPage } from "@sb1f/tracking";
import { transformerTekst } from "~/utils/tracking/utils";

type Props = GridProps & {
	bgColor?: GridBackgroundColor;
	accentMode?: boolean;
	ref?: RefObject<HTMLDivElement | null>;
	pageName?: string;
};
const Grid: FC<Props> = ({ children, className, bgColor, accentMode = false, pageName, ...rest }) => {
	if (pageName) {
		const transformertPageName = transformerTekst(pageName); // formaterer pageName for oss om man ikke har gjort det selv
		return (
			<TrackPage page={transformertPageName}>
				<FfeGrid className={classNames(backgroundColorClass(bgColor), className, { "ffe-accent-mode": accentMode })} {...rest}>
					{children}
				</FfeGrid>
			</TrackPage>
		);
	}
	return (
		<FfeGrid className={classNames(backgroundColorClass(bgColor), className, { "ffe-accent-mode": accentMode })} {...rest}>
			{children}
		</FfeGrid>
	);
};

export default Grid;
